import { cilArrowCircleLeft } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { CCardBody, CCol, CForm, CFormInput, CFormSelect, CSpinner } from '@coreui/react-pro'
import { CircularProgress } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AppHeader } from 'src/business/components'
import { BusinessProfileContext } from 'src/business/context/BusinessProfileContext'
import { validateEmployeeEmail } from 'src/business/services/APIs/ProfessionalProfile/professionalProfileApi'
import { getCustomerDetails } from 'src/services/APIs/Customer/CustomerDetails'
import { addSubscriber } from 'src/services/APIs/Subscriber/addSubscriber'
import { AddSubscriberButton } from './components/styledComponents'

const EMAIL_VALIDATION_MESSAGES = {
  email_required: 'Email is required',
  invalid_email_format: 'Please enter a valid email address',
  email_domain_not_allowed: 'This email domain is not allowed for your organization',
  email_already_used_in_company: 'This email is already used by another employee in your company',
}

const AddSubscriber = () => {
  const { businessCustomerDetails } = useContext(BusinessProfileContext)
  const [validated, setValidated] = useState(false)
  const [email, setEmail] = useState('')
  const [subsName, setSubsName] = useState('')
  const [department, setDepartment] = useState('')
  const [companyLocations, setCompanyLocations] = useState([])
  const [country, setCountry] = useState('')
  const [packages, setPackages] = useState('')
  const [designation, setDesignation] = useState('')
  const [domain, setDomain] = useState([])
  const [loading, setLoading] = useState(false)
  const [buttonLoading, setButtonLoading] = useState(false)

  function validateDomain(email, domain) {
    return domain?.some((val) => email?.includes(val))
  }

  const customer_details = async () => {
    const response = await getCustomerDetails()
    const domain_arr = response.data.domains
    setDomain(domain_arr)
    setCompanyLocations(response.data?.locations || [])
    setCountry(response.data.locations?.[0]?.country || '')
  }

  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    const form = e.currentTarget
    if (form.checkValidity() === false) {
      e.preventDefault()
      e.stopPropagation()
    }
    setValidated(true)
    e.preventDefault()
    if (validateDomain(email, domain) !== true) {
      toast.warning('Please add subscribers from your organization (use a company email domain)')
      return
    }
    setButtonLoading(true)
    try {
      const validationRes = await validateEmployeeEmail({ email, enforceCompanyDomain: true })
      const validation = validationRes?.data
      if (validation && validation.valid === false) {
        const message = EMAIL_VALIDATION_MESSAGES[validation.reason] || validation.reason || 'Invalid email'
        toast.error(message)
        setButtonLoading(false)
        return
      }
      const response = await addSubscriber(
        email,
        subsName,
        department,
        designation,
        packages,
        country,
      )
      if (response?.status === 200) {
        toast.success('User Added Successfully')
        navigate('/workplace/members')
      } else {
        toast.error(response?.data?.message || 'Something went wrong')
      }
    } catch (err) {
      toast.error('Something went wrong')
    } finally {
      setButtonLoading(false)
    }
  }
  function setup() {
    setPackages(businessCustomerDetails?.packageId) //to initially select the first package
  }

  useEffect(() => {
    customer_details()
    setup()
  }, [])

  return (
    <>
      <AppHeader heading="Add Subscriber" />
      {loading ? (
        <CSpinner className={loading ? `block p-4 m-4` : `hidden`} />
      ) : (
        <div className="container-fluid p-5">
          <button
            className="btn btn-ghost-secondary btn-lg"
            onClick={() => {
              navigate(-1)
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <CIcon icon={cilArrowCircleLeft} size="xl" />
              <span style={{ paddingLeft: 5 }}>Back</span>
            </div>
          </button>
          <div className="mb-4 my-20 shadow-xl rounded-lg p-4 bg-cardLight dark:bg-cardDark w-3/5 mx-auto">
            <div className="text-textHeading dark:text-white my-2">
              <p className="font-black text-xl">Add New Subscriber</p>
            </div>
            <CCardBody className="bg-cardLight">
              <CForm
                className="row g-3 needs-validation"
                validated={validated}
                onSubmit={handleSubmit}
              >
                <CCol md={6}>
                  <CFormInput
                    type="name"
                    id="inputName"
                    label="Name of the Subscriber"
                    placeholder="Aman Sharma"
                    feedbackInvalid="Please enter name of the subscriber"
                    value={subsName}
                    valid={subsName !== ''}
                    invalid={subsName === ''}
                    required
                    onChange={(e) => setSubsName(e.target.value)}
                  />
                </CCol>
                <CCol md={6}>
                  <CFormInput
                    type="email"
                    id="inputEmail"
                    label="Email"
                    feedbackInvalid="Please enter an email"
                    valid={/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)}
                    invalid={
                      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) ? false : true
                    }
                    value={email}
                    placeholder="aman@xyz.com"
                    required
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </CCol>
                <CCol md={6}>
                  <CFormInput
                    type="name"
                    id="inputDesignation"
                    label="Designation"
                    placeholder="Designation"
                    onChange={(e) => setDesignation(e.target.value)}
                  />
                </CCol>
                <CCol md={6}>
                  <CFormInput
                    type="name"
                    id="inputDepartment"
                    label="Department"
                    placeholder="Department"
                    onChange={(e) => setDepartment(e.target.value)}
                  />
                </CCol>
                <CCol md={6}>
                  <CFormSelect
                    id="inputPackages"
                    label="Packages"
                    feedbackInvalid="Please specify a package"
                    valid={packages !== ''}
                    invalid={packages === ''}
                    required
                    onChange={(e) => setPackages(e.target.value)}
                  >
                    <option selected value={businessCustomerDetails?.packageId}>
                      Corporate Plan
                    </option>
                  </CFormSelect>
                </CCol>
                <CCol md={6}>
                  <CFormSelect
                    type="text"
                    id="inputCountry"
                    value={country}
                    valid={
                      country !== ''
                        ? companyLocations?.some((location) => location.country === country)
                        : false
                    }
                    invalid={
                      !(country !== ''
                        ? companyLocations?.some((location) => location.country === country)
                        : false)
                    }
                    disabled={companyLocations?.find.length === 0}
                    feedbackInvalid="No branch office has been added yet."
                    label="Country"
                    onChange={(e) => setCountry(e.target.value)}
                    required
                  >
                    {companyLocations?.length !== 0 ? (
                      companyLocations?.map((item, index) => {
                        return index === 0 ? (
                          <option selected key={item.country} value={item.country}>
                            {item.country}
                          </option>
                        ) : (
                          <option key={item.country} value={item.country}>
                            {item.country}
                          </option>
                        )
                      })
                    ) : (
                      <>
                        <option selected disabled>
                          No Countries available
                        </option>
                      </>
                    )}
                  </CFormSelect>
                  {companyLocations?.length === 0 && (
                    <div id="emailHelp" className="form-text">
                      <Link className="text-danger" to="/profile">
                        Add a Branch Office
                      </Link>
                    </div>
                  )}
                </CCol>
                <CCol xs={12}>
                  <AddSubscriberButton type="submit" disabled={buttonLoading} disableRipple>
                    <div style={{ position: 'absolute', display: 'flex', alignItems: 'center' }}>
                      {buttonLoading && (
                        <CircularProgress
                          size={25}
                          sx={{ color: 'rgba(var(--cui-primary-rgb), 1)' }}
                        />
                      )}
                    </div>
                    Add Subscriber
                  </AddSubscriberButton>
                </CCol>
              </CForm>
            </CCardBody>
          </div>
        </div>
      )}
    </>
  )
}

export default AddSubscriber
